import { useLocation } from 'react-router-dom';

import { matchPath } from '@hero/utils/historyUtils';

export function useMatchPath(paths) {
  const { pathname } = useLocation();

  return paths.some(path => {
    if (path instanceof RegExp) return path.test(pathname);
    return !!matchPath(pathname, path);
  });
}
